const digitalData = require('digitalData');
const Localizer = require('Localizer');

class HeaderAnalytics {
  constructor() {
    this.analyticsPromise;
    this.init = this.init.bind(this);
  }

  static createStashEventObject(type, detail) {
    return {
      eventMode: 'stash',
      category: {
        primaryCategory: 'stash',
      },
      eventInfo: {
        eventName: type.toLowerCase(),
      },
      stash: {
        clickInfo: detail.toLowerCase(),
      },
    };
  }

  static createErrorEventObject(error) {
    return {
      category: {
        primaryCategory: 'error',
      },
      eventInfo: {
        eventName: 'post page error',
        error: [
          {
            type: 'error',
            displayType: 'inline',
            pageSection: 'header',
            message: error,
          },
        ],
      },
    };
  }

  _pushEvent(eventObject) {
    return this.analyticsPromise.then(() => {
      this._DDO.event.push(eventObject);
    });
  }

  logError(details) {
    const errorObject = HeaderAnalytics.createErrorEventObject(details);
    return this._pushEvent(errorObject);
  }

  logEvent(type, details) {
    const eventObject = HeaderAnalytics.createStashEventObject(type, details);
    return this._pushEvent(eventObject);
  }

  init() {
    this.analyticsPromise = new Promise((resolve, reject) => {
      Localizer.localize()
        .then(() => {
          this._DDO = digitalData.get();
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}

module.exports = new HeaderAnalytics();
